import type { AppConfig } from '../types/config';

export const defaultConfig: AppConfig = {
  categories: [
    { key: 'motorcycle', label: 'মোটরসাইকেল', fine: 1000, active: true },
    { key: 'car', label: 'প্রাইভেট কার', fine: 3000, active: true },
    { key: 'cng', label: 'সিএনজি', fine: 1500, active: true },
    { key: 'microbus', label: 'মাইক্রোবাস', fine: 2000, active: true },
    { key: 'bus', label: 'বাস', fine: 5000, active: true },
    { key: 'truck', label: 'ট্রাক', fine: 4000, active: true },
    { key: 'pickup', label: 'পিকআপ', fine: 2500, active: true },
    { key: 'other', label: 'অন্যান্য', fine: 2000, active: true },
  ],
  reasons: [
    { id: 'r1', label: 'বৈধ কাগজপত্র না থাকা', extraCharge: 0, active: true },
    { id: 'r2', label: 'ফিটনেস সনদ না থাকা / মেয়াদোত্তীর্ণ', extraCharge: 0, active: true },
    { id: 'r3', label: 'রেজিস্ট্রেশন সংক্রান্ত সমস্যা', extraCharge: 0, active: true },
    { id: 'r4', label: 'ডুপ্লিকেট নম্বরপ্লেটের সন্দেহ', extraCharge: 0, active: true },
    { id: 'r5', label: 'ছোটখাটো দুর্ঘটনা', extraCharge: 0, active: true },
    { id: 'r6', label: 'সড়ক অবরোধ', extraCharge: 0, active: true },
    { id: 'r7', label: 'চালকের অসদাচরণ / সহিংসতা', extraCharge: 0, active: true },
    { id: 'r8', label: 'যানবাহন চলাচলের অনুপযোগী', extraCharge: 0, active: true },
    { id: 'r9', label: 'অন্যান্য অনুমোদিত কারণ', extraCharge: 0, active: true },
  ],
  divisions: [
    { name: 'ট্রাফিক-রমনা বিভাগ', address: 'রমনা, ঢাকা-১০০০', contact: '০২-৯৫১৪৪০০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-রমনা)', jurisdiction: 'শাহবাগ, রমনা, ধানমন্ডি' },
    { name: 'ট্রাফিক-লালবাগ বিভাগ', address: 'লালবাগ, ঢাকা-১২১১', contact: '০২-৯৬৬১২২০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-লালবাগ)', jurisdiction: 'লালবাগ, আজিমপুর, কামরাঙ্গীরচর' },
    { name: 'ট্রাফিক-মতিঝিল বিভাগ', address: 'মতিঝিল, ঢাকা-১০০০', contact: '০২-৯৫৫৬৮৮০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-মতিঝিল)', jurisdiction: 'মতিঝিল, পল্টন, খিলগাঁও' },
    { name: 'ট্রাফিক-ওয়ারী বিভাগ', address: 'ওয়ারী, ঢাকা-১২০৩', contact: '০২-৯৫৬৩৩১০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-ওয়ারী)', jurisdiction: 'ওয়ারী, যাত্রাবাড়ী, সায়েদাবাদ' },
    { name: 'ট্রাফিক-তেজগাঁও বিভাগ', address: 'তেজগাঁও শিল্পাঞ্চল, ঢাকা-১২০৮', contact: '০২-৮৮৭০৪৫৫', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-তেজগাঁও)', jurisdiction: 'ফার্মগেট, তেজগাঁও, মহাখালী' },
    { name: 'ট্রাফিক-মিরপুর বিভাগ', address: 'মিরপুর-২, ঢাকা-১২১৬', contact: '০২-৯০০২৭৬০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-মিরপুর)', jurisdiction: 'মিরপুর, পল্লবী, কাফরুল' },
    { name: 'ট্রাফিক-গুলশান বিভাগ', address: 'গুলশান-১, ঢাকা-১২১২', contact: '০২-৯৮৮৫৬১০', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-গুলশান)', jurisdiction: 'গুলশান, বনানী, বাড্ডা' },
    { name: 'ট্রাফিক-উত্তরা বিভাগ', address: 'উত্তরা সেক্টর-৬, ঢাকা-১২৩০', contact: '০২-৮৯৫৫০৩৩', officer: 'উপ-পুলিশ কমিশনার (ট্রাফিক-উত্তরা)', jurisdiction: 'উত্তরা, বিমানবন্দর, তুরাগ' },
  ],
  stations: [
    { name: 'তেজগাঁও ডাম্পিং স্টেশন', short: 'তেজগাঁও', address: 'তেজগাঁও শিল্পাঞ্চল, ঢাকা-১২০৮', capacity: 220, zones: ['A', 'B', 'C', 'D'], officer: 'মোঃ রাশেদুল ইসলাম', location: { x: 238, y: 222, label: 'তেজগাঁও ডাম্পিং স্টেশন' } },
    { name: 'মিরপুর ডাম্পিং স্টেশন', short: 'মিরপুর', address: 'মিরপুর-১০, ঢাকা-১২১৬', capacity: 160, zones: ['A', 'B', 'C'], officer: 'মোঃ সাইফুল ইসলাম', location: { x: 112, y: 132, label: 'মিরপুর ডাম্পিং স্টেশন' } },
    { name: 'উত্তরা ডাম্পিং স্টেশন', short: 'উত্তরা', address: 'উত্তরা সেক্টর-১০, ঢাকা-১২৩০', capacity: 140, zones: ['A', 'B'], officer: 'মোঃ জসিম উদ্দিন', location: { x: 205, y: 62, label: 'উত্তরা ডাম্পিং স্টেশন' } },
    { name: 'সায়েদাবাদ ডাম্পিং স্টেশন', short: 'সায়েদাবাদ', address: 'সায়েদাবাদ, ঢাকা-১২০৪', capacity: 180, zones: ['A', 'B', 'C', 'D'], officer: 'মোঃ বেলাল হোসেন', location: { x: 302, y: 372, label: 'সায়েদাবাদ ডাম্পিং স্টেশন' } },
  ],
  wreckers: [
    { id: 'WRK-07', vehicleNo: 'ঢাকা মেট্রো-ড-১১-০৭০৭', operator: 'মোঃ সুমন মিয়া', unit: 'ট্রাফিক-তেজগাঁও বিভাগ', status: 'active' },
    { id: 'WRK-03', vehicleNo: 'ঢাকা মেট্রো-ড-১১-০৩০৩', operator: 'মোঃ কবির হোসেন', unit: 'ট্রাফিক-মিরপুর বিভাগ', status: 'active' },
    { id: 'WRK-11', vehicleNo: 'ঢাকা মেট্রো-ড-১২-১১১১', operator: 'মোঃ রুবেল মিয়া', unit: 'ট্রাফিক-ওয়ারী বিভাগ', status: 'active' },
    { id: 'WRK-14', vehicleNo: 'ঢাকা মেট্রো-ড-১২-১৪১৪', operator: 'মোঃ হাসান আলী', unit: 'ট্রাফিক-গুলশান বিভাগ', status: 'maintenance' },
    { id: 'WRK-19', vehicleNo: 'ঢাকা মেট্রো-ড-১৩-১৯১৯', operator: 'মোঃ মামুন হোসেন', unit: 'ট্রাফিক-উত্তরা বিভাগ', status: 'idle' },
  ],
  approvalLevels: [
    { id: 'L1', title: 'দায়িত্বপ্রাপ্ত কর্মকর্তা (যাচাই)', officer: 'মোঃ নাসির উদ্দিন', role: 'verifier', enabled: true },
    { id: 'L2', title: 'নথি প্রস্তুতকারী কর্মকর্তা', officer: 'মোঃ ইমরান হোসেন', role: 'dealing', enabled: true },
    { id: 'L3', title: 'বিভাগীয় অনুমোদনকারী', officer: 'জনাব কামরুল হাসান', role: 'approver', enabled: true },
    { id: 'L4', title: 'অনুমোদিত স্বাক্ষরকারী', officer: 'জনাব শফিকুল ইসলাম', role: 'signatory', enabled: true },
  ],
  docRules: [
    { key: 'reg', name: 'রেজিস্ট্রেশন সার্টিফিকেট', excludeCategories: [], active: true },
    { key: 'license', name: 'ড্রাইভিং লাইসেন্স', excludeCategories: [], active: true },
    { key: 'fitness', name: 'ফিটনেস সার্টিফিকেট', excludeCategories: ['motorcycle'], active: true },
    { key: 'tax', name: 'ট্যাক্স টোকেন', excludeCategories: [], active: true },
    { key: 'nid', name: 'জাতীয় পরিচয়পত্র', excludeCategories: [], active: true },
    { key: 'ownership', name: 'মালিকানার প্রমাণ', excludeCategories: [], active: true },
  ],
  templates: [
    { id: 'receipt', name: 'যানবাহন হেফাজত রসিদ', size: '৮০ মিমি থার্মাল / A5', showLogo: true, showQr: false },
    { id: 'sticker', name: 'আঠাযুক্ত বারকোড স্টিকার', size: '১০০ × ৫০ মিমি', showLogo: false, showQr: false },
    { id: 'note', name: 'সরকারি নোটশিট', size: 'A4 / লিগ্যাল', showLogo: false, showQr: false },
    { id: 'payment', name: 'পেমেন্ট রসিদ', size: 'A5', showLogo: true, showQr: true },
    { id: 'letter', name: 'যানবাহন অবমুক্তি পত্র', size: 'A4', showLogo: true, showQr: true },
  ],
  serviceFee: { enabled: false, amount: 100 },
  deadlineDays: 6,
};

export const DIVISION_STATION: Record<string, string> = {
  'ট্রাফিক-রমনা বিভাগ': 'তেজগাঁও ডাম্পিং স্টেশন',
  'ট্রাফিক-তেজগাঁও বিভাগ': 'তেজগাঁও ডাম্পিং স্টেশন',
  'ট্রাফিক-গুলশান বিভাগ': 'তেজগাঁও ডাম্পিং স্টেশন',
  'ট্রাফিক-মিরপুর বিভাগ': 'মিরপুর ডাম্পিং স্টেশন',
  'ট্রাফিক-উত্তরা বিভাগ': 'উত্তরা ডাম্পিং স্টেশন',
  'ট্রাফিক-মতিঝিল বিভাগ': 'সায়েদাবাদ ডাম্পিং স্টেশন',
  'ট্রাফিক-ওয়ারী বিভাগ': 'সায়েদাবাদ ডাম্পিং স্টেশন',
  'ট্রাফিক-লালবাগ বিভাগ': 'সায়েদাবাদ ডাম্পিং স্টেশন',
};

export const MAP_PLACES = [
  { label: 'ফার্মগেট', x: 190, y: 250, division: 'ট্রাফিক-তেজগাঁও বিভাগ', road: 'ফার্মগেট মোড়, কাজী নজরুল ইসলাম এভিনিউ' },
  { label: 'মহাখালী', x: 242, y: 198, division: 'ট্রাফিক-তেজগাঁও বিভাগ', road: 'মহাখালী বাস টার্মিনাল সংলগ্ন' },
  { label: 'শাহবাগ', x: 200, y: 315, division: 'ট্রাফিক-রমনা বিভাগ', road: 'শাহবাগ মোড়' },
  { label: 'মিরপুর-১০', x: 135, y: 150, division: 'ট্রাফিক-মিরপুর বিভাগ', road: 'মিরপুর-১০ গোলচত্বর' },
  { label: 'বনানী', x: 265, y: 165, division: 'ট্রাফিক-গুলশান বিভাগ', road: 'বনানী ১১ নং রোড' },
  { label: 'মতিঝিল', x: 252, y: 338, division: 'ট্রাফিক-মতিঝিল বিভাগ', road: 'শাপলা চত্বর' },
  { label: 'যাত্রাবাড়ী', x: 292, y: 392, division: 'ট্রাফিক-ওয়ারী বিভাগ', road: 'যাত্রাবাড়ী চৌরাস্তা' },
  { label: 'আজিমপুর', x: 150, y: 365, division: 'ট্রাফিক-লালবাগ বিভাগ', road: 'আজিমপুর বাসস্ট্যান্ড' },
  { label: 'উত্তরা', x: 230, y: 45, division: 'ট্রাফিক-উত্তরা বিভাগ', road: 'আব্দুল্লাহপুর মোড়' },
];
